import React, { useContext, useEffect } from 'react';

import { MDText } from 'i18n-react';

import { captureExceptionWithTeam } from 'Utilities/captureException/captureExceptionWithTeam';
import { TEAM } from 'Utilities/constants';

import { FiguresBox } from '../components/FiguresBox/FiguresBox';
import LocalTexts from '../Payments.text.json';
import { PaymentViewProps } from '../Payments.types';
import { PaymentContext } from '../PaymentsContext';

import { usePaymentLongPooling } from './usePaymentLongPooling';

const LocalT = new MDText(LocalTexts.payments.pendingView);

const PaymentPending = ({ actions }: PaymentViewProps) => {
  const { paymentState: { paymentStatus }, updatePaymentState } = useContext(PaymentContext); // prev status
  const { longPoolingStatus, paymentLongPoolingResult, paymentReference } = usePaymentLongPooling();

  useEffect(() => {
    captureExceptionWithTeam('[PaymentPending] page displayed', TEAM.PAYMENTS_FE, {
      extra: {
        longPoolingStatus,
        paymentLongPoolingResult,
        paymentStatus,
      },
      level: 'info',
    });
  }, [paymentLongPoolingResult, longPoolingStatus, paymentStatus]);

  useEffect(() => {
    if (longPoolingStatus === 'MAX_RETRIES') {
      actions.showHardErrorView();
    } else if (longPoolingStatus === 'SUCCESS') {
      if (paymentLongPoolingResult === 'done' || paymentLongPoolingResult === 'not_required') {
        actions.showSuccessView();
        updatePaymentState({ reference: paymentReference });
      } else if (['failed', 'errored'].includes(paymentLongPoolingResult || '')) {
        actions.showHardErrorView();
      }
    }
  }, [paymentStatus, longPoolingStatus, paymentLongPoolingResult, actions, updatePaymentState, paymentReference]);

  return (
    <FiguresBox
      loading
      content={
        <p>{LocalT.translate('desc')}</p>
      }
      title={paymentLongPoolingResult === 'notApprovedByDealer' ? `${LocalT.translate('titleNotApproved')}` : `${LocalT.translate('titleNotPayment')}`}
    />
  );
};

export { PaymentPending };
